"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyAttributeLinkContainer = exports.TooltipContainer = exports.Label = void 0;
const stitches_config_1 = require("../../../../stitches.config");
exports.Label = (0, stitches_config_1.styled)("span", {
    variants: {
        header: {
            true: {
                margin: "0 0 0 12px",
                fontWeight: stitches_config_1.fontWeights.boldBody,
                width: "100%",
                fontSize: stitches_config_1.fontSizes.body2,
                color: stitches_config_1.colors.contentPrimary,
            },
        },
        size: {
            narrow: {},
            wide: {},
        },
    },
    compoundVariants: [
        {
            header: true,
            size: "wide",
            css: {
                margin: "0",
            },
        },
        {
            header: true,
            size: "narrow",
            css: {
                "@lg": {
                    margin: "0 0 0 20px",
                },
            },
        },
    ],
    defaultVariants: {
        header: false,
    },
});
exports.TooltipContainer = (0, stitches_config_1.styled)("div", {
    whiteSpace: "normal",
    display: "inline",
});
exports.PropertyAttributeLinkContainer = (0, stitches_config_1.styled)("div", {
    display: "flex",
    flexDirection: "row",
    placeContent: "flex-end",
    gap: "4px",
    a: {
        color: stitches_config_1.colors.contentInfo,
    },
    span: {
        color: stitches_config_1.colors.contentPlaceholder,
    },
});
//# sourceMappingURL=data:application/json;base64,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